import { observer } from 'mobx-react';
import ThemeContext from '../../../Themes/ThemeContext';
import { lightTheme } from '../../../Native/styles';
import WithCurrentUser from '../../../CurrentUser/Context/WithCurrentUser';
import EventsStore from '../../../EventsStore';
import CurrentEvents from '../../CurrentEvents';
import * as platformStyle from '../../Platform/style.module.css';
import * as style from '../../Calendar/style.module.css';
import SupplementalCalendarRouter from './SupplementalCalendarRouter';
import LearningCollectionsPanel from '../../LearningCollectionsPanel';
import { T } from '../../../Translations';

interface Props {
  eventsStore: EventsStore;
}

function SupplementalPanel({ eventsStore }: Props) {
  return (
    <WithCurrentUser
      children={(currentUserResource) => (
        <aside className={platformStyle.supPanel2024}>
          <ThemeContext.Provider value={lightTheme}>
            <CurrentEvents eventsStore={eventsStore} />
            <h2
              className={style.supPanelHeader}
              data-test-sup-panel-header="My Learning Collections"
              data-intercom-target="learning-collections-header"
            >
              <T kind="My Learning Collections" />
            </h2>
            <LearningCollectionsPanel />
            <SupplementalCalendarRouter
              eventsStore={eventsStore}
              currentUserResource={currentUserResource}
            />
          </ThemeContext.Provider>
        </aside>
      )}
    />
  );
}

export default observer(SupplementalPanel);
